import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import { facultyGetAllStudents } from '../../redux/action/facultyAction';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory, Link } from 'react-router-dom';
import Loading from '../../Components/Loading';

const FacultyGetAllStudents = () => {
  const store = useSelector((store) => store);
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const [year, setYear] = useState('');
  const [section, setSection] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isDataAvailable, setIsDataAvailable] = useState(false);

  const history = useHistory();
  const department = store.faculty.faculty.faculty.department;

  useEffect(() => {
    dispatch(facultyGetAllStudents({ department }))
      .then(() => {
        setIsDataAvailable(true);
      })
      .catch(() => {
        setIsDataAvailable(false);
      });
  }, [department]);
  

  const filterStudents = () => {
    return store.faculty.allStudent.filter((student) => {
      return (!year || student.year === year) && (!section || student.section === section);
    });
  };

  const searchedStudents = filterStudents().filter((student) => {
    const searchFields = Object.values(student).map((value) => value?.toString() || '');
    const normalizedQuery = searchQuery.toLowerCase().trim();
    return searchFields.some((field) => field.toLowerCase().includes(normalizedQuery));
  });

  const [displayedStudents, setDisplayedStudents] = useState(50);

  const loadMoreStudents = () => {
    setDisplayedStudents(displayedStudents + 50);
  };

  const formHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };

  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> OUR STUDENT'S</h3>
                  <button onClick={() => window.print()} type="button" className="print-helper btn-success btn text-light">
                    <img src="/image/print.svg" alt="" /> Download
                  </button>
                </div>
                <div className="col d-md-flex align-items-center justify-content-between">
                  <form form-inline className='d-md-flex align-items-center justify-content-start' noValidate onSubmit={formHandler}>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="departmentId">Department</label>
                      <h4>{department}</h4>
                      {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                    </div>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="yearId">Year</label>
                      <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control", {
                        'is-invalid': error.year
                      })} id="yearId">
                        <option>Select</option>
                        <option value="I">1</option>
                        <option value="II">2</option>
                        <option value="III">3</option>
                        <option value="IV">4</option>
                      </select>
                      {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                    </div>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="sectionId">Section</label>
                      <select
                        onChange={(e) => {
                          setSection(e.target.value);
                        }}
                        className={classnames('form-control', {
                          'is-invalid': error.section
                        })}
                        id="sectionId"
                      >
                        <option>Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                      </select>
                      {error.section && (
                        <div className="invalid-feedback">{error.section}</div>
                      )}
                    </div>
                    <div className="mt-3">
                      {!isLoading && <button type="submit" className="btn btn-info btn-block print-helper ">
                        <img src="/image/search.svg" className='mb-1' alt="" /> Search
                      </button>}
                      {isLoading && (
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </div>
                    <div className="form-group mx-2 print-helper">
                      <label htmlFor="searchQuery">Search</label>
                      <input
                        type="text"
                        className="form-control"
                        id="searchQuery"
                        placeholder="Search by name, ID, department, etc."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </form>
                </div>
                
                <div className="col">
                  {store.faculty.allStudent.length !== 0 && (
                    <table className="mt-3 table table-responsive table table-bordered table-striped">
                      <thead>
                        <tr className='bg-secondary text-light'>
                          <th scope="col" width="5%">S.No</th>
                          <th scope="col" width="10%">Photo</th>
                          <th scope="col" width="15%">Registration Number</th>
                          <th scope="col" width="20%">Name</th>
                          <th scope="col" width="10%">Year</th>
                          <th scope="col" width="10%">Section</th>
                          <th scope="col" width="10%">Department</th>
                          <th scope="col" width="10%">Status</th>
                          <th scope="col" width="20%" className="print-helper">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {searchedStudents.slice(0, displayedStudents).map((res, index) => (
                          <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td><img src={res.avatar} width={'50px'} style={{ objectFit: 'cover', borderRadius: "50%", height: '50px', border: '2px solid #3D5356' }} alt=""                          />
                            </td>
                            <td>{res.registrationNumber}</td>
                            <td>{res.name}</td>
                            <td>{res.year}</td>
                            <td>{res.section}</td>
                            <td>{res.department}</td>
                            <td>
                              <small className={`badge badge-${res.status === 'active' ? 'success' : res.status === 'irregular' ? 'warning' : 'danger'}`}>{res.status}</small>
                            </td>
                            <td className="print-helper" style={{ whiteSpace: 'nowrap' }}>
                              <small className='bg-info text-light p-1 btn m-1'>
                                <Link to={`FacultyStudentView/${res._id}`} className='text-light'><img src="/image/view.svg" alt="" /> View</Link>
                              </small>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                  {displayedStudents < searchedStudents.length && (
                    <button onClick={loadMoreStudents} className=" m-3 btn btn-primary">
                      Load More
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default FacultyGetAllStudents;

